const styles = theme => ({
  root: {
    alignItems: 'baseline',
    borderRadius: '4px',
    display: 'flex',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 1.5,
    margin: '8px auto',
    paddingBottom: '20px',
    textAlign: 'center',
    transition: 'height 0.1s linear',
    width: '42px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '53px',
      minWidth: '53px'
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '64px'
    },
    '& span': { flex: 1, fontWeight: 'bolder', marginTop: 'auto' }
  },
  typography: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '13px',
      letterSpacing: '0.13px'
    }
  },
  columnValue: {
    display: 'block',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  currencySmallText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '11px'
    }
  }
})

export default styles
